module.exports = __webpack_public_path__ + "media/images/writer/follow_up_mailer/video_8-4adea32382630497cc1719c91cfce8fa.png";